import React, { lazy } from 'react';
export const Story = () => {
  return <div className="py-16 bg-white relative" data-id="element-244">
      {/* American flag corner element */}
      <div className="absolute top-0 right-0 w-16 h-16 md:w-24 md:h-24 overflow-hidden" data-id="element-245">
        <div className="relative w-full h-full" data-id="element-246">
          {/* Red and white stripes */}
          <div className="absolute top-0 left-0 w-full h-full flex flex-col" data-id="element-247">
            {[...Array(13)].map((_, i) => <div key={i} className={`w-full ${i % 2 === 0 ? 'bg-red-700' : 'bg-white'}`} style={{
            height: `${100 / 13}%`
          }} data-id="element-248"></div>)}
          </div>
          {/* Blue canton with stars - now positioned on the left */}
          <div className="absolute top-0 left-0 w-2/5 h-7/13 bg-blue-800" data-id="element-249">
            <div className="w-full h-full flex flex-wrap justify-center items-center p-0.5" data-id="element-250">
              {/* Grid of stars - simplified to 9 stars (3x3 grid) */}
              <div className="grid grid-cols-3 gap-0.5 w-full h-full" data-id="element-251">
                {[...Array(9)].map((_, i) => <div key={i} className="flex items-center justify-center" data-id="element-252">
                    <svg className="w-1.5 h-1.5 md:w-2 md:h-2 text-white" fill="currentColor" viewBox="0 0 24 24" data-id="element-253">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-254" />
                    </svg>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-255">
        <p className="text-lg text-gray-700 mb-8" data-id="element-256">
          Some people chase degrees or elections to gain influence. Charlie Kirk
          didn't need either. Armed only with conviction and a microphone, he
          built a youth movement that championed American values and challenged
          the dominant culture on American campuses.
        </p>
        <p className="text-lg text-gray-700 mb-8" data-id="element-257">
          At just 18, he founded Turning Point USA. What began with a handful of
          students and posters has grown into a national force defending liberty
          and constitutional principles on more than 1,000 campuses.
        </p>
        <p className="text-lg text-gray-700 mb-12" data-id="element-258">
          Today, millions follow him, criticize him, or admire him—but no one
          ignores him. And now his story, strategies, and most powerful quotes
          are revealed in{' '}
          <span className="italic font-medium" data-id="element-259">
            Charlie Kirk: Life, Quotes & Legacy
          </span>
          .
        </p>
        <div className="bg-blue-50 border-l-4 border-blue-700 p-6 mb-12" data-id="element-260">
          <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-261">
            <span className="text-red-700 mr-2" data-id="element-262">★</span>
            The question that changed everything
          </h3>
          <p className="text-lg text-gray-700 mb-4" data-id="element-263">
            At a time when many young people kept quiet out of fear of
            censorship, Kirk asked:
          </p>
          <blockquote className="text-xl italic font-medium text-gray-800 pl-4 border-l-4 border-red-700 my-6" data-id="element-264">
            "Who is defending freedom in the classroom? Who is standing up for
            students who don't think like the majority?"
          </blockquote>
          <p className="text-lg text-gray-700" data-id="element-265">
            That question didn't just spark debate—it sparked a movement to
            restore American values on campus.
          </p>
        </div>
        <div className="flex justify-center my-12 relative" data-id="element-266">
          <div className="absolute inset-0 rounded-lg border-4 border-transparent bg-gradient-to-r from-red-700 via-white to-blue-700 opacity-50" data-id="element-267"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oAFvBu4zanVmKQj42oEeo1/Gemini_Generated_Image_yydrsayydrsayydr.png" alt="Charlie Kirk Book on Bookshelf" className="w-full max-w-2xl rounded-lg shadow-lg relative z-10" loading="lazy" width="600" height="400" data-id="element-268" />
        </div>
      </div>
    </div>;
};